import React, { useRef, useState, useEffect } from 'react';
import './index.css';

function FormulatorRow({
  data,
  onSelectedItemChange,
  onHitChange,
  onBlur,
  grandTotal,
  customValue,
  isVehicle1,
  onCustomChange,
  customVehicle1,
  standardValue,
  onStandardChange,
  standardSize,
  isEditableStandard,
  isEditMode
}) {
  const standardSizeOptions = ["", "Quart", "Gallon", "5 Gallon"];
  const [localHits, setLocalHits] = useState(data.hits);
  const inputRefs = useRef([]);
  const lastValueRef = useRef([]);

  // Sync local state with props
  useEffect(() => {
    console.log(`useEffect: Syncing localHits with data.hits=`, data.hits);
    setLocalHits(data.hits);
    lastValueRef.current = data.hits.slice();
  }, [data.hits]);

  const handleHitChange = (index, value) => {
    if (!isEditMode) return;
    console.log(`handleHitChange: index=${index}, value=${value}`);
    // Allow numeric or empty values
    if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
    const newHits = [...localHits];
    newHits[index] = value;
    lastValueRef.current[index] = value;
    setLocalHits(newHits);
    onHitChange(index, value);
  };

  const handleBlur = (index, value) => {
    if (!isEditMode) return;
    console.log(`handleBlur: index=${index}, value=${value}`);
    const parsedValue = value === '' ? '' : parseFloat(value).toFixed(1);
    lastValueRef.current[index] = parsedValue;
    onBlur(index, parsedValue);
  };

  const handleKeyPress = (e) => {
    if (e.key.startsWith('Arrow')) {
      console.log(`handleKeyPress: key=${e.key}, value=${e.target.value}`);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleKeyDown = (e) => {
    console.log(`handleKeyDown: key=${e.key}, value=${e.target.value}, inputIndex=${inputRefs.current.indexOf(e.target)}`);

    if (!e.key.startsWith('Arrow')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const input = e.target;
    const index = inputRefs.current.indexOf(input);
    // Store current value
    lastValueRef.current[index] = input.value;
    handleBlur(index, input.value);
    input.blur();

    const table = input.closest('table');
    const rows = Array.from(table.querySelectorAll('tr')).filter(tr =>
      tr.querySelector('input[type="text"]') !== null
    );
    const currentRow = input.closest('tr');
    const currentRowIndex = rows.indexOf(currentRow);
    const currentInputs = Array.from(currentRow.querySelectorAll('input[type="text"]:not(:disabled)'));
    const currentInputIndex = currentInputs.indexOf(input);

    let nextInput = null;

    switch (e.key) {
      case 'ArrowRight':
        if (currentInputIndex < currentInputs.length - 1) {
          nextInput = currentInputs[currentInputIndex + 1];
        }
        break;
      case 'ArrowLeft':
        if (currentInputIndex > 0) {
          nextInput = currentInputs[currentInputIndex - 1];
        }
        break;
      case 'ArrowUp':
        if (currentRowIndex > 0) {
          const prevRow = rows[currentRowIndex - 1];
          const prevInputs = Array.from(prevRow.querySelectorAll('input[type="text"]:not(:disabled)'));
          if (prevInputs[currentInputIndex]) {
            nextInput = prevInputs[currentInputIndex];
          }
        }
        break;
      case 'ArrowDown':
        if (currentRowIndex < rows.length - 1) {
          const nextRow = rows[currentRowIndex + 1];
          const nextInputs = Array.from(nextRow.querySelectorAll('input[type="text"]:not(:disabled)'));
          if (nextInputs[currentInputIndex]) {
            nextInput = nextInputs[currentInputIndex];
          }
        }
        break;
      default:
        break;
    }

    if (nextInput) {
      console.log(`Navigating to next input: value=${nextInput.value}`);
      nextInput.focus();
      nextInput.select();
    }
  };

  const totalGrams = localHits.reduce((sum, hit) => sum + (parseFloat(hit) || 0), 0);
  const percentage = grandTotal > 0 && totalGrams > 0
    ? ((totalGrams / parseFloat(grandTotal)) * 100).toFixed(1) + '%'
    : '';

  return (
    <tr>
      <td>
        {isEditMode ? (
          <select
            value={data.selectedItem || ''}
            onChange={(e) => {
              if (!isEditMode) return;
              onSelectedItemChange(e.target.value);
            }}
            disabled={!isEditMode}
            style={{ width: '100%' }}
          >
            <option value="">Select {data.label.split(' ')[0]}</option>
            {data.options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        ) : (
          <span>{data.selectedItem || data.label}</span>
        )}
      </td>
      {[0, 1, 2, 3].map(index => (
        <td key={index}>
          <input
            type="text"
            value={localHits[index]}
            onChange={(e) => handleHitChange(index, e.target.value)}
            onBlur={(e) => handleBlur(index, e.target.value)}
            onKeyPress={handleKeyPress}
            onKeyDown={handleKeyDown}
            disabled={!isEditMode}
            ref={(el) => (inputRefs.current[index] = el)}
            style={{ width: '100%' }}
          />
        </td>
      ))}
      <td>{totalGrams.toFixed(1)}g</td>
      <td>{percentage}</td>
      <td>
        {isVehicle1 ? (
          <input
            type="text"
            value={customVehicle1}
            onChange={(e) => onCustomChange(e.target.value)}
            onKeyPress={handleKeyPress}
            onKeyDown={handleKeyDown}
            ref={(el) => (inputRefs.current[4] = el)}
            style={{ width: '100%' }}
          />
        ) : (
          customValue || ''
        )}
      </td>
      <td>
        {isEditableStandard ? (
          <select
            value={standardSize}
            onChange={(e) => onStandardChange(e.target.value)}
            style={{ width: '100%' }}
          >
            {standardSizeOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        ) : (
          standardValue || ''
        )}
      </td>
    </tr>
  );
}

export default FormulatorRow;